import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminSetup = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the new create admin page
    navigate('/create-admin');
  }, [navigate]);

  return null;
};

export default AdminSetup;